import Env from 'enviro';
import invariant from 'react-utils/invariant';
import { MetaTypeToTypeId } from 'flow-doctor-lib/constants/ObjectMetaTypes';
// https://tools.hubteamqa.com/puma/events?search=e_property_value_changed
export const getIsPropertyChangedEvent = objectTypeId => Env.isQa() ? objectTypeId === '4-67284' : objectTypeId === '4-655002';

//https://tools.hubteam.com/puma/events?query=form_submission_v2
export const getIsFormSubmissionEvent = objectTypeId => Env.isQa() ? objectTypeId === '4-829203' : objectTypeId === '4-1639801';
export const getIsObjectCreatedEvent = objectTypeId => Env.isQa() ? objectTypeId === '4-530516' : objectTypeId === '4-1463224';
export const getObjectTypeIdFromFlowEventFilter = flowEventFilter => {
  const {
    metaType,
    innerId
  } = flowEventFilter.eventFilter.eventTypeId;
  return `${MetaTypeToTypeId[metaType]}-${innerId}`;
};
export const getObjectTypeIdFromObject = objectTypeId => {
  return `${objectTypeId.metaTypeId}-${objectTypeId.innerId}`;
};

// Since property value changed events are special-cased behind-the-scenes we need to render
// it in a way that makes sense to customers.
export const mapToRenderableFilterBranch = (objectTypeId, filterBranch) => {
  if (getIsPropertyChangedEvent(objectTypeId)) {
    invariant(filterBranch.filterBranchType === 'AND', `Expected a filterBranch type of AND, but got ${filterBranch.filterBranchType}`);
    invariant(filterBranch.filters.length === 2, `Expected an 'hs_name' and 'hs_value' filter, but got ${filterBranch.filters}`);
    const [nameFilter, valueFilter] = filterBranch.filters;
    return Object.assign({}, filterBranch, {
      filters: [Object.assign({}, valueFilter, {
        property: nameFilter.operation.value
      })]
    });
  }

  // If not property change event, don't do anything special
  return filterBranch;
};
const makeEvaluationDataForDebugFilter = (nameDebugFilter, valueDebugFilter) => {
  const combinedILSFilter = Object.assign({}, valueDebugFilter.filter, {
    property: nameDebugFilter.filter.operation.value
  });
  const acceptedStatus = nameDebugFilter.acceptedStatus === 'ACCEPTED' && valueDebugFilter.acceptedStatus === 'ACCEPTED' ? 'ACCEPTED' : 'REJECTED';
  if (acceptedStatus === 'ACCEPTED' || nameDebugFilter.acceptedStatus === 'ACCEPTED' && valueDebugFilter.acceptedStatus === 'REJECTED') {
    return {
      filter: combinedILSFilter,
      index: 0,
      acceptedStatus,
      evaluationData: [{
        dataType: 'PropertyValue',
        matchingFilterValues: valueDebugFilter.evaluationData[0].matchingFilterValues,
        propertyValue: Object.assign({}, valueDebugFilter.evaluationData[0].propertyValue, {
          name: combinedILSFilter.property
        })
      }]
    };
  }

  // Must be a rejected value with non-matching name
  return {
    filter: combinedILSFilter,
    index: 0,
    acceptedStatus,
    evaluationData: [{
      dataType: 'PropertyValue',
      matchingFilterValues: [],
      propertyValue: null
    }]
  };
};

// Same as `mapToRenderableFilterBranch`, but for debug filter branches
export const mapToRenderableDebugFilterBranch = (objectTypeId, filterBranch) => {
  const propertyDebugBranch = filterBranch;
  if (getIsPropertyChangedEvent(objectTypeId)) {
    invariant(propertyDebugBranch.filterBranchOperator === 'AND', `Expected a debug filterBranch type of AND, but got ${filterBranch.filterBranchOperator}`);
    invariant(propertyDebugBranch.filters.length === 2, `Expected an 'hs_name' and 'hs_value' filter, but got ${propertyDebugBranch.filters}`);
    const [nameDebugFilter, valueDebugFilter] = propertyDebugBranch.filters;
    const combinedDebugFilter = makeEvaluationDataForDebugFilter(nameDebugFilter, valueDebugFilter);
    if (combinedDebugFilter.acceptedStatus === 'ACCEPTED') {
      return Object.assign({}, propertyDebugBranch, {
        acceptedStatus: combinedDebugFilter.acceptedStatus,
        acceptedFilters: [combinedDebugFilter],
        filters: [combinedDebugFilter]
      });
    } else {
      return Object.assign({}, propertyDebugBranch, {
        acceptedStatus: combinedDebugFilter.acceptedStatus,
        rejectedFilters: [combinedDebugFilter],
        filters: [combinedDebugFilter]
      });
    }
  }

  // If not property change event, don't do anything special
  return propertyDebugBranch;
};